import React, { Fragment } from "react";

import img13 from "../../../images/service/Solana Blockchain Development/1.png";
import img14 from "../../../images/service/Solana Blockchain Development/2.png";
import img15 from "../../../images/service/Solana Blockchain Development/3.png";
// Service icons
import sIcon1 from "../../../images/icon/service-icon01.svg";
import sIcon2 from "../../../images/icon/service-icon02.svg";
import sIcon3 from "../../../images/icon/service-icon03.svg";
import sIcon4 from "../../../images/icon/service-icon04.svg";
import sIcon5 from "../../../images/icon/service-icon05.svg";
import sIcon6 from "../../../images/icon/service-icon06.svg";

// Common Components
import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";

import HeroSection from "../../../components/PageSection/HeroSection";
import ServiceCardsSection from "../../../components/PageSection/ServiceCardSection";
import Benefit from "../../../components/PageSection/BenefitSection";
import KeyFeaturesSection from "../../../components/PageSection/KeyFeature";
import WhyChooseUsSection from "../../../components/PageSection/WhyChooseUsSection";
import FaqSection from "../../../components/PageSection/FAQsection";
import FinalCenteredCTA from "../../../components/PageSection/FinalCTA";
import Industries from "../../../components/Industries/Industries";
import TheorySection from "../../../components/PageSection/Theory";

// =====================
// DATA
// =====================

const serviceCards = [
  {
    icon: sIcon1,
    title: "Solana dApp Development",
    content:
      "Build high-performance decentralized applications on Solana with ultra-fast transactions and low fees.",
  },
  {
    icon: sIcon2,
    title: "Solana Smart Contract Development",
    content:
      "Develop secure and optimized Solana programs using Rust for scalable blockchain applications.",
  },
  {
    icon: sIcon3,
    title: "Solana Token & NFT Development",
    content:
      "Launch SPL tokens and NFT platforms with seamless wallet and marketplace integration.",
  },
];

const benefits = [
  {
    title: "High Transaction Speed",
    description:
      "Solana processes thousands of transactions per second with minimal latency.",
    icon: sIcon1,
  },
  {
    title: "Low Transaction Costs",
    description:
      "Ultra-low fees make Solana ideal for high-frequency and consumer-facing applications.",
    icon: sIcon2,
  },
  {
    title: "Scalable Infrastructure",
    description:
      "Built for large-scale adoption without compromising performance.",
    icon: sIcon3,
  },
  {
    title: "Developer-Friendly Ecosystem",
    description:
      "Strong tooling, SDKs, and community support accelerate development.",
    icon: sIcon4,
  },
];

const faqs = [
  {
    q: "What makes Solana different from other blockchains?",
    a: "Solana uses a unique Proof of History mechanism that enables extremely fast and low-cost transactions.",
  },
  {
    q: "Is Solana suitable for DeFi and NFT projects?",
    a: "Yes. Solana is widely used for DeFi, NFT marketplaces, and gaming due to its speed and scalability.",
  },
  {
    q: "Do you build custom Solana programs?",
    a: "Absolutely. We design and develop custom Solana programs using Rust tailored to your business logic.",
  },
  {
    q: "Can Solana integrate with existing systems?",
    a: "Yes. Solana applications can integrate with wallets, exchanges, and external APIs seamlessly.",
  },
];

// =====================
// PAGE COMPONENT
// =====================

export default function SolanaBlockchainDevelopment() {
  return (
    <Fragment>
      <Header />

      <PageTitle
        pageTitle="Solana Blockchain Development"
        pagesub="High-performance, low-cost blockchain solutions on Solana"
      />

      {/* HERO SECTION */}
      <HeroSection
        title={
          <>
            Build High-Speed Apps with{" "}
            <span className="gradient-text">Solana Blockchain</span>
          </>
        }
        subtitle={`Leverage Solana’s lightning-fast performance to build scalable,
cost-efficient decentralized applications for DeFi, NFTs, and Web3 platforms.`}
        buttonText="Book Consultation"
        buttonLink="/contact"
        image={img13}
        imageAlt="Solana Blockchain Development"
      />

      {/* ================= THEORY 1 ================= */}
      <TheorySection
        title="Why Choose Solana Blockchain?"
        image={img14}
        paragraphs={[
          "Solana is designed for speed and scalability, making it one of the fastest public blockchains available today. Its architecture enables high throughput without sacrificing decentralization.",
          "With minimal transaction fees and strong ecosystem support, Solana is ideal for applications that require real-time performance and mass user adoption.",
        ]}
      />

      {/* SERVICES */}
      <ServiceCardsSection
        title="Our Solana Blockchain Development Services"
        cards={serviceCards}
      />

      {/* ================= THEORY 2 ================= */}
      <TheorySection
        title="Challenges with Traditional Blockchains"
        image={img15}
        paragraphs={[
          "Many blockchains face scalability limitations, high gas fees, and slow transaction finality.",
          "Solana overcomes these issues by combining Proof of History with optimized consensus mechanisms for unmatched performance.",
        ]}
      />

      {/* BENEFITS */}
      <Benefit
        title="Benefits of Solana Blockchain Development"
        benefits={benefits}
      />

      {/* KEY FEATURES */}
      <KeyFeaturesSection
        title="Key Features of Our Solana Solutions"
        subtitle="Built for speed, scalability, and real-world adoption"
        features={[
          {
            icon: sIcon1,
            title: "Proof of History Consensus",
            description:
              "Enables rapid transaction ordering and high throughput.",
          },
          {
            icon: sIcon2,
            title: "Low Latency Execution",
            description:
              "Support real-time use cases like trading and gaming.",
          },
          {
            icon: sIcon3,
            title: "SPL Token Standards",
            description:
              "Create tokens and NFTs using Solana’s native standards.",
          },
          {
            icon: sIcon4,
            title: "High Network Scalability",
            description:
              "Handle millions of users without congestion.",
          },
          {
            icon: sIcon5,
            title: "Secure Rust-Based Programs",
            description:
              "Robust smart contract development with Rust.",
          },
          {
            icon: sIcon6,
            title: "Ecosystem Integration",
            description:
              "Seamless integration with Solana wallets and tools.",
          },
        ]}
      />

      <Industries />

      {/* WHY CHOOSE US */}
      <WhyChooseUsSection
        items={[
          "Deep expertise in Solana architecture",
          "Performance-optimized blockchain solutions",
          "End-to-end Solana development support",
        ]}
      />

      {/* FAQ */}
      <FaqSection faqs={faqs} />

      {/* FINAL CTA */}
      <FinalCenteredCTA />

      <Footer />
      <Scrollbar />
    </Fragment>
  );
}
